/* eslint-disable react/display-name */
/**
 *
 * FormularioPreguntas
 *
 */

import { memo } from 'react';

import { lazyLoad } from 'utils/loadable';

import { NonComplianceRouting } from './non-compliance.routing';
interface Props {}

export const OmissionComponent = memo((props: Props) => {
  return (
    <>
      <NonComplianceRouting />
    </>
  );
});

export const NonComplianceModule = lazyLoad(
  () => import('./non-compliance.module'),
  (module) => module.OmissionComponent
);
